// src/pages/admin/TransactionsPage.js
import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../components/Layout/DashboardLayout';
import TransactionsTablePage from '../shared/SharedTransactionsPage';
import { useNavigate } from 'react-router-dom';
import { getUserFromStorage } from '../../utils/auth';

const AdminTransactionsPage = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = getUserFromStorage();
    if (storedUser?.role === 'admin') {
      setUser(storedUser);
    } else {
      navigate('/login'); // ✅ redirect if not admin
    }
  }, [navigate]);

  if (!user) return null;

  return (
    <DashboardLayout role="admin">
      <TransactionsTablePage user={user} />
    </DashboardLayout>
  );
};

export default AdminTransactionsPage;